export interface RuntimeConfig {
  apiOrigin: string;
  websocketOrigin: string;
}

export function createRuntimeConfig(rawOrigin: string | undefined, locationOrigin: string): RuntimeConfig {
  const apiOrigin = normalizeOrigin(rawOrigin ?? locationOrigin);
  const parsed = new URL(apiOrigin);
  parsed.protocol = parsed.protocol === 'https:' ? 'wss:' : 'ws:';
  return { apiOrigin, websocketOrigin: parsed.origin };
}

function normalizeOrigin(value: string): string {
  const parsed = new URL(value);
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    throw new Error('VITE_API_ORIGIN must use http or https');
  }
  return parsed.origin;
}
